import { FunctionComponent } from 'react';
import { QuickStart, SignUp, TeamInvite } from 'modules';

interface Route {
  path: string;
  component: FunctionComponent;
}

export const getRoutes = (): Array<Route> => {
  return [
    {
      path: '/',
      component: SignUp,
    },
    {
      path: '/:clientType',
      component: SignUp,
    },
    {
      path: '/invite-user',
      component: TeamInvite,
    },
    {
      path: '/invite-admin',
      component: TeamInvite,
    },
    {
      path: '/quick-start',
      component: QuickStart,
    },
  ];
};
